export const getWebPrice = ({ webPrice, listPrice, isLoggedIn }) => {
  return isLoggedIn ? webPrice : listPrice
}
